/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaseGetControlQueryResultValidationResult } from './CaseGetControlQueryResultValidationResult';
import {
	CaseGetControlQueryResultValidationResultFromJSON,
	CaseGetControlQueryResultValidationResultFromJSONTyped,
	CaseGetControlQueryResultValidationResultToJSON,
	CaseGetControlQueryResultValidationResultToJSONTyped,
} from './CaseGetControlQueryResultValidationResult';
import type { EasyClaimDocumentType } from './EasyClaimDocumentType';
import {
	EasyClaimDocumentTypeFromJSON,
	EasyClaimDocumentTypeFromJSONTyped,
	EasyClaimDocumentTypeToJSON,
	EasyClaimDocumentTypeToJSONTyped,
} from './EasyClaimDocumentType';
import type { CustomerJourneyQuestion } from './CustomerJourneyQuestion';
import {
	CustomerJourneyQuestionFromJSON,
	CustomerJourneyQuestionFromJSONTyped,
	CustomerJourneyQuestionToJSON,
	CustomerJourneyQuestionToJSONTyped,
} from './CustomerJourneyQuestion';

/**
 *
 * @export
 * @interface ControlConfiguration
 */
export interface ControlConfiguration {
	/**
	 *
	 * @type {string}
	 * @memberof ControlConfiguration
	 */
	id?: string | null;
	/**
	 *
	 * @type {EasyClaimDocumentType}
	 * @memberof ControlConfiguration
	 */
	documentType?: EasyClaimDocumentType;
	/**
	 *
	 * @type {CustomerJourneyQuestion}
	 * @memberof ControlConfiguration
	 */
	customerJourneyQuestion?: CustomerJourneyQuestion;
	/**
	 *
	 * @type {boolean}
	 * @memberof ControlConfiguration
	 */
	isRequired?: boolean | null;
	/**
	 *
	 * @type {Array<CaseGetControlQueryResultValidationResult>}
	 * @memberof ControlConfiguration
	 */
	validationResults?: Array<CaseGetControlQueryResultValidationResult> | null;
	/**
	 *
	 * @type {string}
	 * @memberof ControlConfiguration
	 */
	value?: string | null;
}

/**
 * Check if a given object implements the ControlConfiguration interface.
 */
export function instanceOfControlConfiguration(value: object): value is ControlConfiguration {
	return true;
}

export function ControlConfigurationFromJSON(json: any): ControlConfiguration {
	return ControlConfigurationFromJSONTyped(json, false);
}

export function ControlConfigurationFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ControlConfiguration {
	if (json == null) {
		return json;
	}
	return {
		id: json['id'] == null ? undefined : json['id'],
		documentType:
			json['documentType'] == null
				? undefined
				: EasyClaimDocumentTypeFromJSON(json['documentType']),
		customerJourneyQuestion:
			json['customerJourneyQuestion'] == null
				? undefined
				: CustomerJourneyQuestionFromJSON(json['customerJourneyQuestion']),
		isRequired: json['isRequired'] == null ? undefined : json['isRequired'],
		validationResults:
			json['validationResults'] == null
				? undefined
				: (json['validationResults'] as Array<any>).map(
						CaseGetControlQueryResultValidationResultFromJSON
					),
		value: json['value'] == null ? undefined : json['value'],
	};
}

export function ControlConfigurationToJSON(json: any): ControlConfiguration {
	return ControlConfigurationToJSONTyped(json, false);
}

export function ControlConfigurationToJSONTyped(
	value?: ControlConfiguration | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		id: value['id'],
		documentType: EasyClaimDocumentTypeToJSON(value['documentType']),
		customerJourneyQuestion: CustomerJourneyQuestionToJSON(value['customerJourneyQuestion']),
		isRequired: value['isRequired'],
		validationResults:
			value['validationResults'] == null
				? undefined
				: (value['validationResults'] as Array<any>).map(
						CaseGetControlQueryResultValidationResultToJSON
					),
		value: value['value'],
	};
}
